import {
  SubtleButtonExternalBulletLink,
  SubtleButtonExternalLink,
  SubtleButtonProps,
} from "@mgdx/ui/components/SubtleButton";
import { type AnchorHTMLAttributes } from "react";

import { useAppExternalLink } from "../../hooks/useAppExternalLink";

export type SubtleButtonAppExternalLinkProps = { isBullet?: boolean } & SubtleButtonProps &
  AnchorHTMLAttributes<HTMLAnchorElement>;

export const SubtleButtonAppExternalLink = ({
  href,
  onClick,
  isBullet,
  ...props
}: Readonly<SubtleButtonAppExternalLinkProps>) => {
  const { href: resolvedHref, onClick: resolvedOnClick, target } = useAppExternalLink({ href, onClick });

  if (isBullet) {
    return <SubtleButtonExternalBulletLink {...props} href={resolvedHref} target={target} onClick={resolvedOnClick} />;
  }

  return <SubtleButtonExternalLink {...props} href={resolvedHref} target={target} onClick={resolvedOnClick} />;
};
